<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Cute Cupcakes</h1>
<p class="BOD2">Who doesn’t love a cupcake! Make a whole batch and surround yourself with sweetness.</p>
<p class="IMAGE"><img alt="" src="images/C1-21.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-22.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-11.vue?3dd4b5c6